const STRUCT = {
  ID: 'id',
  TITLE: 'title',
};

export default STRUCT;
